import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=2b3edbd1&scoped=true&"
import script from "./VideoPlay.vue?vue&type=script&lang=js&"
export * from "./VideoPlay.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlay.vue?vue&type=style&index=0&id=2b3edbd1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3edbd1",
  null
  
)

export default component.exports